import React from 'react';
import { Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import {
    DISTANCE_LABELS, DISTANCE_OPTIONS_MIN, DISTANCE_OPTIONS_MAX
} from 'constants/filterOptions';
import Box from '@mui/material/Box';
import SearchFilterUtil from 'lib/SearchFilterUtil';
import RangeAutocomplete from 'components/FilterFields/RangeAutocomplete';
import { validateDecimalPlaces, validateDistance, validateMaxLength } from 'lib/Validations';

function AdvancedDistanceFilter(props) {
    const validateInput = (input) => {
        return (
            validateDistance(input) ||
            validateMaxLength(input) ||
            validateDecimalPlaces(input)
        );
    };
    return (
        <Box
            sx={{
                mb: 2,
                width: '100%',
            }}
        >
            <Typography sx={{ mb: 2.5, display: 'block' }} variant="text4" gutterBottom>Distances</Typography>
            <Grid container spacing={3}>
                {
                    Object.keys(DISTANCE_LABELS).map(distance => {

                        return (
                            <Grid item size={4} key={distance}>
                                <RangeAutocomplete
                                    comparableType={props.comparableType}
                                    attrName={distance}
                                    label={DISTANCE_LABELS[distance]}
                                    subLabel="Select an option or manually enter a value"
                                    minOptions={DISTANCE_OPTIONS_MIN}
                                    maxOptions={DISTANCE_OPTIONS_MAX}
                                    isDropdown={false}
                                    formatter={SearchFilterUtil.formatDistance}
                                    validateInput={validateInput}
                                />
                            </Grid>
                        );
                    })
                }
            </Grid>
            <Divider orientation="horizontal" sx={{mt: 3, mb: 3}}/>
        </Box>
    );
}

export default React.memo(AdvancedDistanceFilter);